/**
 * filterRailWrapperContainer.tsx
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const FilterRailWrapperContainer = styled.div<{ displayRail?: boolean }>`
  align-items: center;
  display: ${({ displayRail }) => `${displayRail ? 'flex' : 'none'}`};
  margin-bottom: ${20 * Screen.widthRatio}px;
`;

export default FilterRailWrapperContainer;
